import React, { useState, useEffect } from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { getApi } from '~/util/api'
import { Card, Typography } from '~/components/_atoms'
import { Stack } from '~/components/_layouts'
import Spinner from '~/components/shared/Spinner'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '~/lib/ui/carousel'
import YnsIcon from '~/components/icons/YnsIcon'
import { useFormatTime } from '~/hooks/useFormatTime'
import parse from 'html-react-parser'

export function NetworkingEventsCard({
  className,
  color = 'secondary',
  variant = 'default',
}) {
  const { t, locale } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [calendarEvents, setCalendarEvents] = useState({ events: [] })
  const formatTime = useFormatTime(locale)

  useEffect(() => {
    setIsLoading(true)
    getApi()
      .get('coach_services/upcoming_webinars', {
        params: { only_networking: true, only_pending: true },
      })
      .then((response) => {
        if (response.status == 200) {
          setCalendarEvents(response.data)
          return
        } else {
          throw new Error('json request failed')
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
      .catch((error) => {
        console.log('json request failed', error)
      })
  }, [setCalendarEvents])

  return (
    <Card
      className={className}
      color={color}
      variant={variant}
      title={t('networking_events_card.title')}
      titleColor="secondary"
      icon={<YnsIcon name="calendar" size={42} />}
    >
      <Stack spacing={3}>
        <Typography className="mb-2">
          {parse(t('networking_events_card.description'))}
        </Typography>
        {isLoading ? (
          <div className="flex items-center justify-center ">
            <Spinner show className="h-9 w-9" />
          </div>
        ) : (
          <div className="grid grid-cols-[1fr] gap-x-8">
            {/* <Typography variant="subtitle" color="secondary">
              {t('networking_events_card.upcoming_webinars_title')}
            </Typography> */}
            <div className="grid w-full grid-cols-12">
              <div className="col-span-8 pt-4">
                {calendarEvents.events.length === 0 ? (
                  <Typography>
                    {t('networking_events_card.no_upcoming_events')}
                  </Typography>
                ) : (
                  <Carousel className="ml-12 w-full">
                    <CarouselContent>
                      {calendarEvents.events.map((event) => (
                        <CarouselItem
                          key={`event_${event.id}`}
                          className="pl-8"
                        >
                          <div>
                            <Stack spacing={1}>
                              <Typography color="secondary">
                                <a
                                  className="text-intoo-green-medium !underline hover:text-intoo-green-medium-900 focus:text-intoo-green-medium-900 active:text-intoo-green-medium-900"
                                  href={`/coach_services/upcoming_events?event_id=${event.id}&mode=list`}
                                >
                                  {event.webinar_type}
                                  {event.is_gec_event ? (
                                    <>
                                      : A{' '}
                                      <strong>
                                        Global Executive Community
                                      </strong>{' '}
                                      event hosted by{' '}
                                      <strong>Career Star Group</strong>
                                    </>
                                  ) : (
                                    ''
                                  )}{' '}
                                </a>
                              </Typography>
                              <Typography color="secondary">
                                {formatTime(event.start_at)}
                              </Typography>
                              <Typography color="secondary" component="span">
                                {event.description}
                                {event.is_gec_event ? (
                                  <a href="/networking/gec_events">
                                    {' '}
                                    {'Learn More'}
                                  </a>
                                ) : (
                                  ''
                                )}
                              </Typography>
                            </Stack>
                          </div>
                        </CarouselItem>
                      ))}
                    </CarouselContent>
                    <CarouselPrevious className="hover:text-text-intoo-green-medium-800 h-10 w-10 border-2 border-intoo-green-medium-800  bg-willow-brook-50 font-semibold text-intoo-green-medium-800 hover:bg-intoo-green-medium-100" />
                    <CarouselNext className="hover:text-text-intoo-green-medium-800 h-10 w-10 border-2 border-intoo-green-medium-800 bg-willow-brook-50 font-semibold text-intoo-green-medium-800 hover:bg-intoo-green-medium-100" />
                  </Carousel>
                )}
              </div>
              <div className="col-span-4 pr-12">
                <img
                  src="https://www-yns-com.s3.us-east-2.amazonaws.com/images/dashboard/networking_events.png"
                  alt="Networking Events"
                  className="float-right hidden xl:!visible xl:!block"
                />
              </div>
            </div>
          </div>
        )}
      </Stack>
    </Card>
  )
}
